export enum ReasonType {
  adWatched = 'AdWatched',
}
